export const CHAT_TAB = "chat" as const;
export const ACTIVITY_TAB = "activity" as const;
export const TAB_PARAM = "tab" as const;

export type ChatTabType = typeof CHAT_TAB | typeof ACTIVITY_TAB;

export const ARCHIVED_CHAT_TAB = "CLOSED" as const;
